import React from 'react';

class KioskSummary extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;

    let kioskImgPath = '/img/V5-MM-200.png';
    if (hostInfo.kioskHW !== 'RT') {
      if (/CS/.test(hostInfo.sfecfgServices)) {
        kioskImgPath = '/img/RT-CS-200.jpg';
      } else {
        kioskImgPath = '/img/RT-SS-200.jpg';
      }
    }

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>kiosk summary</div>
        </div>

        <div className='info-card pure-u-4-24'>
          <span>Kiosk Name:</span>
          <div>
            {hostInfo.kioskName}
            {hostInfo.kioskType && <i style={{ fontSize: 12 }}> (type: {hostInfo.kioskType})</i>}
            {hostInfo.kioskName !== hostInfo.capuiDeviceName && (
              <div style={{ padding: '0', color: 'red', textAlign: 'left', fontSize: 12 }}>
                {hostInfo.capuiDeviceName} (in capui)
              </div>
            )}
          </div>
          {!hostInfo.hasSosdbKiosk && (
            <div style={{ padding: '0', color: 'red', textAlign: 'left', fontSize: 12 }}>
              Kiosk not found under location in ADM
            </div>
          )}
        </div>
        <div className='info-card pure-u-12-24'>
          <span>Location:</span>
          <div>
            {hostInfo.locationName}
            {hostInfo.sosdbLocName !== hostInfo.locationName && hostInfo.sosdbLocName && (
              <div style={{ padding: '0', color: 'red', textAlign: 'left', fontSize: 12 }}>
                {hostInfo.sosdbLocName} (in ADM)
              </div>
            )}
            {!hostInfo.sosdbLocName && (
              <div style={{ padding: '0', color: 'red', textAlign: 'left', fontSize: 12 }}>
                (Location not found in ADM)
              </div>
            )}
          </div>
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Org:</span>
          <div>
            {hostInfo.orgName}
            {hostInfo.sosdbOrgName !== hostInfo.orgName && hostInfo.sosdbOrgName && (
              <div style={{ padding: '0', color: 'red', textAlign: 'left', fontSize: 12 }}>
                {hostInfo.sosdbOrgName} (in ADM)
              </div>
            )}
            {!hostInfo.sosdbOrgName && (
              <div style={{ padding: '0', color: 'red', textAlign: 'left', fontSize: 12 }}>
                (Org not found in ADM)
              </div>
            )}
          </div>
        </div>

        <div className='info-card pure-u-10-24'>
          <span>Services:</span>
          {hostInfo.sfecfgServicesText}
        </div>
        <div className='info-card pure-u-8-24'>
          <span>Kiosk ISO:</span>
          {hostInfo.kioskISOVersion}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Timezone (in ADM):</span>
          {/yes/i.test(hostInfo.kskSameTimezone) ? (
            <div style={{ color: '' }}>
              {hostInfo.sosdbTimezone || '-'}
              <br />
              {hostInfo.sosdbTimezoneLong}
            </div>
          ) : (
            <div style={{ color: '' }}>
              {hostInfo.sosdbTimezone || '-'}
              <br />
              {hostInfo.sosdbTimezoneLong}
              {hostInfo.sosdbTimezoneLong && hostInfo.timezoneLong ? (
                <div style={{ padding: '0', color: 'red', textAlign: 'left', fontSize: 12 }}>
                  actual: {hostInfo.timezoneLong}
                </div>
              ) : null}
            </div>
          )}
        </div>

        <div className='info-card pure-u-6-24'>
          <span>Last TransId:</span>
          {hostInfo.sosdbLastTransId || '-'}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Last TransDate</span>
          {hostInfo.sosdbLastTranDate || '-'}{' '}
          {hostInfo.sosdbLastTranDate ? '(' + hostInfo.sosdbLastTranDateXAgo + ')' : ''}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Last Full Sync</span>
          {hostInfo.sosdbLastFullSync || '-'}{' '}
          {hostInfo.sosdbLastFullSync ? '(' + hostInfo.sosdbLastFullSyncXAgo + ')' : ''}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Last Update Prices</span>
          {hostInfo.sosdbLastUpdPrices || '-'}{' '}
          {hostInfo.sosdbLastUpdPrices ? '(' + hostInfo.sosdbLastUpdPricesXAgo + ')' : ''}
        </div>

        <div className='info-card pure-u-6-24'>
          <span>Touchscreen:</span>
          {hostInfo.touchscreenType === 'unknown' ? '-' : hostInfo.touchscreenType}
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Touch Driver</span>
          {hostInfo.kioskTouchDriver || '-'}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Temperature Sensor:</span>
          {hostInfo.usbTemperatureSensor || '-'}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Line Display:</span>
          {hostInfo.usbCustomerLineDisplay || '-'}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Coin Dispenser:</span>
          {hostInfo.usbCoinDispenser || '-'}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Cashless Reader:</span>
          {hostInfo.usbCashlessReader || '-'}
        </div>

        <div className='info-card pure-u-1-6'>
          <span>Barcode Scanner:</span>
          {hostInfo.usbBarcodeScanner || '-'}
        </div>
        <div className='info-card pure-u-1-6'>
          <span>MSR:</span>
          {hostInfo.usbMSR || '-'}
        </div>
        <div className='info-card pure-u-1-6'>
          <span>Printer:</span>
          {hostInfo.usbPrinter || '-'}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Scale:</span>
          {hostInfo.usbScale || '-'}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Camera:</span>
          {hostInfo.usbWebCam || '-'}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Fingerprint Reader:</span>
          {hostInfo.usbFingerprintReader || '-'}
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Bill Acceptor:</span>
          {hostInfo.usbBillAcceptor || '-'}
        </div>
        <div className='info-card pure-u-1-6'>
          <span>OptConnect serial number:</span>
          {hostInfo.optConnectSerialNumber || '-'}
        </div>
        <div className='info-card pure-u-1-6'>
          <span>Castles Serial Number:</span>
          {hostInfo.castlesSerialNumber || '-'}
        </div>
      </div>
    );
  }
}

export default KioskSummary;



// WEBPACK FOOTER //
// ./src/components/KioskSummary.js